import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";

import tableIcons from "./FormIcon";

const FormComponent = ({ fieldsConfig, db }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!!db) {
      (async () => {
        setData(await db.read());
      })();
    }
  }, [db]);

  return (
    <div style={{ maxWidth: "100%" }}>
      <MaterialTable
        minRows={10}
        icons={tableIcons}
        columns={fieldsConfig.fields}
        data={data}
        title={fieldsConfig.tableTitle}
        options={{
          pageSize: 10,
          pageSizeOptions: [10, 20, 50, 100, 200, 500],
          toolbar: true,
        }}
        editable={{
          onRowAdd: (newData) =>
            new Promise(async (resolve, reject) => {
              try {
                await db.create(newData);
              } catch (e) {
                reject(e);
              }
              setData(await db.read());
              resolve();
            }),
          onRowUpdate: (newData, oldData) =>
            new Promise((resolve, reject) => {
              const dataUpdate = [...data];
              const index = oldData.tableData.id;
              try {
                db.update(newData, oldData.id);
                dataUpdate[index] = newData;
                setData([...dataUpdate]);
                resolve();
              } catch (e) {
                reject(e);
              }
            }),
          onRowDelete: (oldData) =>
            new Promise((resolve, reject) => {
              const dataDelete = [...data];
              const index = oldData.tableData.id;
              try {
                db.delete(oldData.id);
                dataDelete.splice(index, 1);
                setData([...dataDelete]);
                resolve();
              } catch (e) {
                reject(e);
              }
            }),
        }}
      />
    </div>
  );
};

export default FormComponent;
